const CustomAppEvents = {
    INIT_STATE: "initState",
    LOAD_SCRIPT: "loadScript",
    SHOW_GAPI: "showGapi",
    CONVERT_METADATA: "convertMetadata",
    GET_SORT_OPTION: "getSortOption",
    GET_MF_DATA: "getMfData",
    SHOW_MF_INFO: "showMfInfo",
    INIT_FORM_DATA: "initFormData",
    SETUP_DROPDOWN: "setupDropdown",
    INIT_GRANTING: "initGranting",
    CHECK_GRANTING: "checkGranting",
    GET_USER_DATA: "getUserData",
    GET_FORM_TABS: "getFormTabs",
    UPDATE_SEARCH_OBJ: "updateSearchObjects",
    CHANGE_SEARCH_OBJ: "changeSearchObjects",
    GET_ICON: "getIcon",
    GET_AWE_ICON: "getAweIcon",
    GET_FONT_ICON: "getFontIcon",
    CHANGE_FORM_STYLE: "changeFormStyle",
    GET_FORM_COUNT: "getFormLeftCount",
}

export default CustomAppEvents;